module.exports = __webpack_public_path__ + "img/2.22d12087.svg";